class ErrorPayload {
  error = null;

  /** @type {{ body: object; fn: string; params: unknown, statusCode: number }} */
  metadata = null;

  constructor(error, metadata = {}) {
    this.error = error;
    this.metadata = { ...metadata };
  }
}

export default ErrorPayload;
